import { ServiceResponse } from "../ServiceResponse";

export class InsertPageStatusResponse extends ServiceResponse {
  public PageStatusId: number | null = null;
  public InsertSuccess: boolean = false;
}
